import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../../supabase/supabase';

const { FiMusic, FiUnlock, FiHeart, FiDollarSign, FiStar, FiMessageSquare, FiClock } = FiIcons;

const EVENT_CONFIG = {
  drop_published: { icon: FiMusic, color: 'text-brand-pink', label: 'New Drop' },
  drop_unlocked: { icon: FiUnlock, color: 'text-brand-coral', label: 'Drop Unlocked' },
  follow: { icon: FiHeart, color: 'text-pink-500', label: 'New Follower' },
  subscribe: { icon: FiStar, color: 'text-purple-500', label: 'New Subscriber' },
  merch_purchased: { icon: FiDollarSign, color: 'text-green-500', label: 'Merch Sale' },
  shoutout: { icon: FiMessageSquare, color: 'text-yellow-500', label: 'Shoutout' },
  milestone: { icon: FiStar, color: 'text-blue-500', label: 'Milestone' },
};

const ActivityItem = ({ activity }) => {
  const config = EVENT_CONFIG[activity.event_type] || EVENT_CONFIG.drop_published;
  const Icon = config.icon;

  return (
    <div className="flex items-start gap-4 p-4 glass-card rounded-2xl hover:border-brand-pink/20 transition-all">
      <div className={`w-10 h-10 rounded-xl bg-zinc-900 flex items-center justify-center flex-shrink-0`}>
        <SafeIcon icon={Icon} className={`text-lg ${config.color}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-black text-sm uppercase tracking-tight text-white">
          {config.label}
        </p>
        <p className="text-xs font-bold text-zinc-500 mt-0.5 truncate">
          {activity.payload?.title || activity.payload?.fan_name || 'Activity'}
        </p>
        <div className="flex items-center gap-2 mt-2">
          <SafeIcon icon={FiClock} className="text-xs text-zinc-600" />
          <span className="text-[10px] font-bold text-zinc-600">
            {new Date(activity.created_at).toLocaleDateString()}
          </span>
        </div>
      </div>
    </div>
  );
};

const ArtistActivityFeed = ({ artistId, limit = 10 }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!artistId) return;

    const fetchActivities = async () => {
      const { data, error } = await supabase
        .from('d2f_artist_activity')
        .select('*')
        .eq('artist_id', artistId)
        .eq('is_public', true)
        .order('created_at', { ascending: false })
        .limit(limit);

      if (!error && data) setActivities(data);
      setLoading(false);
    };

    fetchActivities();
  }, [artistId, limit]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <SafeIcon icon={FiClock} className="text-2xl text-brand-pink animate-spin" />
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="text-center py-12 glass-card rounded-2xl">
        <SafeIcon icon={FiMusic} className="text-3xl text-zinc-700 mx-auto mb-3" />
        <p className="font-black text-sm uppercase tracking-tight text-zinc-500">No Activity Yet</p>
        <p className="text-xs font-bold text-zinc-700 mt-1">Activity will appear here</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {activities.map(activity => (
        <ActivityItem key={activity.id} activity={activity} />
      ))}
    </div>
  );
};

export default ArtistActivityFeed;